import { render, staticRenderFns } from "./color-aspects.vue?vue&type=template&id=06255d3c"
import script from "./color-aspects.vue?vue&type=script&lang=js"
export * from "./color-aspects.vue?vue&type=script&lang=js"
import style0 from "./color-aspects.vue?vue&type=style&index=0&id=06255d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports